import { createI18n } from "vue-i18n";
import ru from "@/i18n/ru.json";
import bg from "@/i18n/bg.json";

export default createI18n({
  legacy: false,
  locale: "ru",
  fallbackLocale: "ru",
  messages: { ru, bg },
});
